import { toast } from 'sonner';
import { ErrorToast } from './ErrorToast/ErrorToast';
import { SuccessToast } from './SuccessToast/SuccessToast';

export type ToastPosition = Required<
  Required<Parameters<typeof toast.custom>>[1]
>['position'];

export type ToastOptions = {
  description?: string;
  duration?: number;
  onAutoClose?: () => void;
  onClose?: () => void;
  position?: ToastPosition;
  title: string;
};

export const successToast = ({
  description,
  duration = 5000,
  onAutoClose,
  onClose,
  position = 'top-center',
  title,
}: ToastOptions): void => {
  toast.custom(
    (id) => (
      <SuccessToast
        description={description}
        id={id}
        onClose={() => {
          if (onClose) {
            onClose();
          }
          toast.dismiss(id);
        }}
        title={title}
      />
    ),
    { duration, onAutoClose, position },
  );
};

export const errorToast = ({
  description,
  duration = 5000,
  onAutoClose,
  onClose,
  position = 'top-center',
  title,
}: ToastOptions): void => {
  toast.custom(
    (id) => (
      <ErrorToast
        description={description}
        id={id}
        onClose={() => {
          if (onClose) {
            onClose();
          }
          toast.dismiss(id);
        }}
        title={title}
      />
    ),
    { duration, onAutoClose, position },
  );
};
